import { SfArrowLeftIcon } from 'fitify-ui/src/Icon/outline/SfArrowLeftIcon'
import { useTranslation } from 'next-i18next/pages'

import { IconButton } from '../../GenderFunnel/Button/IconButton'
import { TextButton } from '../../GenderFunnel/Button/TextButton'
import { Modal } from '../../Modal/Modal'
import { useModal } from '../../Modal/useModal'
import { Typography } from '../../Typography'

import {
  StyledActionsContainer,
  StyledContainer,
  StyledHeaderContainer,
  StyledImage,
  StyledImagesContainer,
  StyledStory,
  StyledStoryContainer,
} from './UserResultCard.Styled'
import type { UserResultCardProps } from './UserResultCard.Types'
import { UserResultCardProfile } from './UserResultCardProfile'

export const UserResultCard = ({
  name,
  result,
  story,
  imageAfter,
  imageBefore,
  imageProfile,
  onClickPrev,
  onClickNext,
}: UserResultCardProps) => {
  const { t } = useTranslation()
  const { isOpen, handleOpen, handleClose, modalRef } = useModal()

  return (
    <>
      <StyledContainer>
        <StyledHeaderContainer>
          <UserResultCardProfile
            imageProfile={imageProfile}
            name={name}
            result={result}
          />
        </StyledHeaderContainer>
        <StyledImagesContainer>
          <StyledImage {...imageBefore} alt="Image before" />
          <StyledImage {...imageAfter} alt="Image after" />
        </StyledImagesContainer>
        <StyledStoryContainer>
          <StyledStory $variant="Poppins/T2">{story}</StyledStory>
          <StyledActionsContainer>
            <IconButton onClick={onClickPrev}>
              <SfArrowLeftIcon />
            </IconButton>
            <TextButton data-testid="read-more" onClick={handleOpen}>
              {t('paywall_read_more')}
            </TextButton>
            <IconButton onClick={onClickNext}>
              <SfArrowLeftIcon style={{ transform: `rotate(-180deg)` }} />
            </IconButton>
          </StyledActionsContainer>
        </StyledStoryContainer>
      </StyledContainer>
      <Modal
        id="user-result-card-detail"
        backgroundColor="primary"
        header={
          <UserResultCardProfile
            imageProfile={imageProfile}
            name={name}
            result={result}
          />
        }
        isOpen={isOpen}
        onClose={handleClose}
        ref={modalRef}
      >
        <Typography $variant="Poppins/T2">{story}</Typography>
      </Modal>
    </>
  )
}
